import React, { Component } from 'react'
import { connect } from 'react-redux';
import * as sounds from '../../constants/Sounds'
import * as Sound from 'soundmanager2'
import SoundLibrary from './SoundLibrary'

class SoundComponent extends Component {

    constructor(props) {
        super(props);

        this.CurrentSound = null;
        this.Settings = window.SoundSettings;
        this.soundManager = window.soundManager;//new Sound.SoundManager();
        window.SoundComponent = this;
        this.Settings = window.SoundSettings;

        this.ChantingIsPlaying = false;
        this.ChantingStartedFrom = null;
        this.SoundLibrary = new SoundLibrary(5,6,5000);
    }

    componentDidMount() {
        this.initSounds();
        window.onSoundChange = (volume, noiseVolume) => {
            this.onVolumeChange(volume, noiseVolume);
        }
    }

    initSounds() {
        let _this = this;
        
        return new Promise(function(resolve, reject) {
            this.soundManager.setup({
                onready: function() {
                    _this.preLoadFiles();
                    //_this.startCrowdNoise();
                    if(_this.props.Muted)
                        _this.onMute();
                    resolve();
                }
            })
        }.bind(this));
    }

    initSound(id, path) {
        return this.soundManager.createSound({
                    id: id,
                    autoLoad: true,
                    url: path,
                });
    }

    preLoadFiles() {
        let files = this.SoundLibrary.GetFileListForInitialDownload();
        let requestResult = this.SoundLibrary.RequestSound(sounds.LOOP);
        for (var index = 0; index < files.length; index++) {
            var file = files[index];
            let sound = this.initSound(file.id, file.path);
            if(file.id == requestResult[0].id){
                this.loopSound = sound;
                this.loopSoundVolume = requestResult[0].volume;
            }
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.currentEvent != prevProps.currentEvent) {
          if(Math.abs(this.props.currentEvent - prevProps.currentEvent) > 1) {
            this.onMoveFarAway();
          } else {
            this.onNextEvent();
          }
        }

        if(this.props.Paused != prevProps.Paused) {
            if(this.props.Paused == true)
                this.onPause();
            else
                this.onResume(); 
        }

        if(this.props.Muted != prevProps.Muted) {
            if(this.props.Muted == true)
                this.onMute();
            else
                this.onUnMute(); 
        }
    }

    onNextEvent() {
        //console.log('onNextEvent');
        if(this.ChantingIsPlaying == false && this.props.currentEvent == 100) {
            this.startChanting();
        }
    }

    onMoveFarAway() {
        //console.log('onMoveFarAway');
        if(this.props.Replay == false)
            this.stopChanting();
    }

    onPause() {
        //console.log('onPause');
        this.soundManager.pauseAll();
    }

    onResume() {
        //console.log('onResume');
        this.soundManager.resumeAll();
        if(this.CrowdNoiseStarted != true) 
            this.startCrowdNoise()
    }

    onUnMute() {
        this.soundManager.unmuteAll();
    }

    onMute() {
        this.soundManager.muteAll();
    }

    onVolumeChange(volume, noiseVolume) {
        if(this.loopSound != null)
            this.loopSound.setVolume(noiseVolume * this.loopSoundVolume);
    }

    onShotEnd(home, distance, isGoal, isBlocked) {
        //console.log(`on shot end home = ${home} distance = ${distance} isGoal = ${isGoal}`);
        if(isGoal)
            this.playGoal(home);
        else {
            if(isBlocked != true){
                if(home) {
                    if(distance < 12*100/16.5)
                        this.play(sounds.NEAR_MISS)
                    else
                        this.play(sounds.Ohh)
                }
                else {
                    this.play(sounds.AWAY_MISS)
                }
            }
            else {
                
            }
        }
    }

    onGoal(home) {
        this.playGoal(home);
    }

    startCrowdNoise() {
        this.loopSound.play({loops: 100, volume: this.Settings.NoiseVolume * this.loopSoundVolume});
        this.CrowdNoiseStarted = true;
    }

    stopCrowdNoise() {
        this.loopSound.stop();
    }

    startChanting() {
        this.ChantingIsPlaying = true;
        this.ChantingStartedFrom = this.props.currentEvent;
        //this.play(sounds.MakSim).then(() => this.ChantingIsPlaying = false);
    }

    stopChanting() {
        this.ChantingIsPlaying = false;
        //this.soundManager.stop(sounds.MakSim);
    }

    play(sound, home) {
        return new Promise(function(resolve, reject) {
            if(sound == sounds.SHORT_PASS && this.Settings.ShortPassAnimation == false){
                resolve();
                return;
            }

            try{
                //console.log(`playing sound ${sound}`)
                let requestResult = this.SoundLibrary.RequestSound(sound, home);
                if(requestResult != null && requestResult.length != 0) {
                    let file = requestResult[0];
                    let s = this.soundManager.getSoundById(file.id);//todo add probability process
                    if(s != null && !this.props.Replay)
                        s.play({ volume: this.Settings.Volume * file.volume, onFinish: function() { resolve() } });//todo add volume process
                }
            }
            catch(e){
                console.log(`error playing sound: ${e}`)
                resolve()
            }
        }.bind(this));
    }

    playGoal(home = true) {
        if(home)
            this.play(sounds.GOAL_HOME, true);
        else
            this.play(sounds.GOAL_AWAY);
    }

    render() {
        return null;
    }
}

function loopSound(sound) {
    sound.play({
      onfinish: function() {
        loopSound(sound);
      }
    });
}

function mapStateToProps(state, ownProps) {
    return {
        Score: state.Score,
        currentEvent: state.currentEvent,
        Paused: state.paused,
        Muted: state.muted,
        Replay: state.replay != null
    };
}

export default connect(mapStateToProps)(SoundComponent)



/** WEBPACK FOOTER **
 ** ./src/components/Sound/SoundComponent.js
 **/